import { isEmptyObject } from "@bounce/util"

import { OverrideMode, useVariantOverrides } from "./useVariantOverrides"
import { useVariants } from "./useVariants"

export const useAreVariantsReady = () => {
  const hasLoaded = useVariants(({ variants }) => !isEmptyObject(variants))
  const isOnlyUsingOverrides = useVariantOverrides.useMode() === OverrideMode.OverridesOnly

  return hasLoaded || isOnlyUsingOverrides
}
